import {
  AvailableFlagPermissions,
  AvailablePermissionFlagsValue,
  RequiredPermissions,
  AvailableGlobalPermissions,
} from 'features/validateAccess';

const getTimesheetsLocalPermission = (
  accountId: string,
  projectId: string,
  timesheetPermission: AvailableFlagPermissions,
): RequiredPermissions => [
  [
    {
      type: 'flagLocal',
      global: AvailableGlobalPermissions.ACCOUNT,
      subFlagGlobal: timesheetPermission,
      parent: accountId,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    {
      type: 'flagLocal',
      global: AvailableGlobalPermissions.PROJECT,
      subFlagGlobal: timesheetPermission,
      parent: projectId,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
  ],
];

export const getTimesheetsViewPermission = (accountId: string, projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_PERIOD_VIEW,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    ...getTimesheetsLocalPermission(accountId, projectId, AvailableFlagPermissions.TIMESHEET_PERIOD_VIEW)[0],
  ],
];

export const getTimesheetsReopenPermission = (accountId: string, projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_PERIOD_REOPEN,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    ...getTimesheetsLocalPermission(accountId, projectId, AvailableFlagPermissions.TIMESHEET_PERIOD_REOPEN)[0],
  ],
];

export const getTimesheetsClosePermission = (accountId: string, projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_PERIOD_CLOSE,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    ...getTimesheetsLocalPermission(accountId, projectId, AvailableFlagPermissions.TIMESHEET_PERIOD_CLOSE)[0],
  ],
];

export const getTimesheetsApprovePermission = (accountId: string, projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_APPROVE,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    ...getTimesheetsLocalPermission(accountId, projectId, AvailableFlagPermissions.TIMESHEET_APPROVE)[0],
  ],
];

export const getTimesheetsEditPermission = (accountId: string, projectId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableFlagPermissions.TIMESHEET_EDIT,
      value: AvailablePermissionFlagsValue.ENABLE,
    },
    ...getTimesheetsLocalPermission(accountId, projectId, AvailableFlagPermissions.TIMESHEET_EDIT)[0],
  ],
];
